var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BCard, BCol, BFormGroup, BRow } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { GalaxyApi } from "@/api";
import {} from "@/api/notifications";
import { Toast } from "@/composables/toast";
import { errorMessageAsString } from "@/utils/simple-error";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import Heading from "@/components/Common/Heading.vue";
import FormElement from "@/components/Form/FormElement.vue";
import GDateTime from "@/components/GDateTime.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import MessageNotification from "@/components/Notifications/Categories/MessageNotification.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationForm',
    setup(__props) {
        library.add(faInfoCircle);
        const router = useRouter();
        const loading = ref(false);
        const roles = ref([]);
        const users = ref([]);
        const groups = ref([]);
        const notificationData = ref({
            notification: {
                source: "admin",
                category: "message",
                variant: "info",
                content: {
                    category: "message",
                    subject: "",
                    message: "",
                },
                expiration_time: new Date(Date.now() + 6 * 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16),
                publication_time: new Date().toISOString().slice(0, 16),
            },
            recipients: {
                user_ids: [],
                role_ids: [],
                group_ids: [],
            },
        });
        const requiredFieldsFilled = computed(() => {
            var _a, _b, _c;
            return (notificationData.value.notification.content.subject !== "" &&
                notificationData.value.notification.content.message !== "" &&
                (((_a = notificationData.value.recipients.user_ids) === null || _a === void 0 ? void 0 : _a.length) ||
                    ((_b = notificationData.value.recipients.role_ids) === null || _b === void 0 ? void 0 : _b.length) ||
                    ((_c = notificationData.value.recipients.group_ids) === null || _c === void 0 ? void 0 : _c.length)));
        });
        const publicationDate = computed({
            get: () => {
                return new Date(`${notificationData.value.notification.publication_time}Z`);
            },
            set: (value) => {
                notificationData.value.notification.publication_time = value.toISOString().slice(0, 16);
            },
        });
        const expirationDate = computed({
            get: () => {
                return new Date(`${notificationData.value.notification.expiration_time}Z`);
            },
            set: (value) => {
                notificationData.value.notification.expiration_time = value.toISOString().slice(0, 16);
            },
        });
        const isUrgent = computed(() => notificationData.value.notification.variant === "urgent");
        function loadData(getData, target, formatter) {
            return __awaiter(this, void 0, void 0, function* () {
                const tmp = yield getData();
                target.value = tmp.map(formatter);
            });
        }
        function getAllGroups() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/groups");
                if (error) {
                    Toast.error(errorMessageAsString(error));
                    return [];
                }
                return data;
            });
        }
        function getAllRoles() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/roles");
                if (error) {
                    Toast.error(errorMessageAsString(error));
                    return [];
                }
                return data;
            });
        }
        // TODO: this can potentially be a very large list, consider adding filters
        function getAllUsers() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().GET("/api/users");
                if (error) {
                    Toast.error(errorMessageAsString(error));
                    return [];
                }
                return data;
            });
        }
        loadData(getAllUsers, users, (user) => {
            return [`${user.username} | ${user.email}`, user.id];
        });
        loadData(getAllRoles, roles, (role) => {
            return [`${role.name} | ${role.description}`, role.id];
        });
        loadData(getAllGroups, groups, (group) => {
            return [`${group.name}`, group.id];
        });
        function sendNewNotification() {
            return __awaiter(this, void 0, void 0, function* () {
                const { error } = yield GalaxyApi().POST("/api/notifications", {
                    body: notificationData.value,
                });
                if (error) {
                    Toast.error(errorMessageAsString(error));
                    return;
                }
                Toast.success("Notification sent");
                router.push("/admin/notifications");
            });
        }
        return { __sfc: true, router, loading, roles, users, groups, notificationData, requiredFieldsFilled, publicationDate, expirationDate, isUrgent, loadData, getAllGroups, getAllRoles, getAllUsers, sendNewNotification, faInfoCircle, FontAwesomeIcon, BAlert, BCard, BCol, BFormGroup, BRow, AsyncButton, Heading, FormElement, GDateTime, LoadingSpan, MessageNotification };
    }
});
